import { Logo } from '@/components/icons';
import { MobileAppBadges } from '@/components/MobileAppBadges';
import { Button } from '@/components/ui/button';
import { PlaceHolderImages } from '@/lib/placeholder-images';
import { Link } from 'react-router-dom';

export default function LandingPage() {
  const heroImage = PlaceHolderImages.find(img => img.id === 'hero-cooking');

  return (
    <div className="flex flex-col min-h-screen">
      <header className="px-4 lg:px-6 h-16 flex items-center shadow-sm">
        <Link to="/" className="flex items-center justify-center">
          <Logo className="h-10 w-10 text-primary" sizes="40px" />
          <span className="sr-only">ezRecipeBox</span>
        </Link>
        <nav className="ml-auto flex gap-4 sm:gap-6">
          <Button variant="ghost" asChild>
            <Link to="/login">
              Login
            </Link>
          </Button>
          <Button asChild>
            <Link to="/signup">
              Sign Up
            </Link>
          </Button>
        </nav>
      </header>
      <main className="flex-1 flex items-center justify-center">
        <section className="w-full py-12 md:py-24 lg:py-32">
          <div className="container mx-auto px-4 md:px-6">
            <div className="grid gap-10 lg:grid-cols-[1fr_420px] lg:items-center lg:gap-12 xl:grid-cols-[1fr_560px]">
              <div className="flex flex-col justify-center space-y-5">
                <div className="space-y-2">
                  <h1 className="font-headline text-3xl font-bold tracking-tighter sm:text-5xl xl:text-6xl/none">
                    The secret ingredient is always love. And this app.
                  </h1>
                  <p className="max-w-[600px] text-muted-foreground md:text-xl">
                    Welcome to ezRecipeBox. Your family&apos;s cherished recipes, organized and accessible anytime, anywhere. Create, share, and cook together.
                  </p>
                </div>
                <div className="flex flex-col gap-2 min-[400px]:flex-row">
                  <Button size="lg" asChild>
                    <Link to="/signup">
                      Get Started for Free
                    </Link>
                  </Button>
                  <Button size="lg" variant="secondary" asChild>
                    <Link to="/login">
                      I have an account
                    </Link>
                  </Button>
                </div>
                <MobileAppBadges className="mt-4" />
              </div>
              {heroImage && (
                <div className="relative mx-auto w-full max-w-[560px] overflow-hidden rounded-xl bg-muted shadow-sm aspect-[4/3] lg:mx-0 lg:justify-self-end lg:aspect-square">
                  <img
                    src={heroImage.imageUrl}
                    alt={heroImage.description}
                    className="w-full h-full object-cover"
                    data-ai-hint={heroImage.imageHint}
                  />
                </div>
              )}
            </div>
          </div>
        </section>
      </main>
      <footer className="flex flex-col gap-2 sm:flex-row py-6 w-full shrink-0 items-center px-4 md:px-6 border-t">
        <p className="text-xs text-muted-foreground">&copy; 2025 ezRecipeBox. All rights reserved.</p>
        <nav className="sm:ml-auto flex gap-4">
          <Link to="/privacy" className="text-xs text-muted-foreground hover:underline underline-offset-4">
            Privacy Policy
          </Link>
          <Link to="/terms" className="text-xs text-muted-foreground hover:underline underline-offset-4">
            Terms of Service
          </Link>
        </nav>
      </footer>
    </div>
  );
}

